<template>
  <v-row 
    v-if="settings" 
    class="px-2" 
    justify="center" 
    align="center" 
    no-gutters
    :min-height="minHeight"
  >
    <v-col align="center" cols="12">
      <h1
        :style="
          `
          font-family: ${MIXIN_getStyle(settings, 'title', 'font')} !important; 
          font-size: ${MIXIN_getStyle(settings, 'title', 'font-size')} !important; 
          color: ${MIXIN_getStyle(settings, 'title', 'color')} !important; 
          line-height: ${MIXIN_getStyle(settings, 'title', 'font-size')} !important; 
          font-weight: ${MIXIN_getStyle(settings, 'title', 'weight')} !important;
          font-style: ${MIXIN_getStyle(settings, 'title', 'font-style')} !important;
          `
        "
      >
        {{ settings.title ? settings.title.content : "" }}
      </h1>
    </v-col>

    <v-col v-if="settings.subtitle" align="center" cols="12" class="pt-2">
      <b
        :style="
          `
          font-family: ${MIXIN_getStyle(settings, 'subtitle', 'font')} !important; 
          font-size: ${MIXIN_getStyle(settings, 'subtitle', 'font-size')} !important; 
          color: ${MIXIN_getStyle(settings, 'subtitle', 'color')} !important; 
          line-height: ${MIXIN_getStyle(settings, 'subtitle', 'font-size')} !important; 
          font-weight: ${MIXIN_getStyle(settings, 'subtitle', 'weight')} !important;
          font-style: ${MIXIN_getStyle(settings, 'subtitle', 'font-style')} !important;
          `
        "
      >
      {{ settings.subtitle ? settings.subtitle.content : "" }}
    </b>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import { GetLayoutSectionMixin } from "../../mixins/GetLayoutSection"

export default {
  mixins: [GetLayoutSectionMixin],
  props: {
    settings: { type: Object, default: () => {} },
    minHeight: { type: String, default: '70px' }
  },

  computed: {
    ...mapGetters(["infos"]),
  },

  created () {
    // console.log('@.@',this.id, this.settings) // para saber de onde o title component é criado.
  }
};
</script>

<style scoped>
h1 {
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: 44px;
  letter-spacing: 0px;
}

b {
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.15000000596046448px;
}
</style>